import {Avatar, Typography} from "@material-tailwind/react";
import {BsCheckSquare, BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import Dict from "../../../helper/dict";
import React, {useContext, useState} from "react";
import {getFileUrl} from "../../../config";
import {TableHead} from "../../system/thead";
import {PaginateContext} from "../../../context/paginate";
import TableTdDateTime from "../../system/tableTdDateTime";


const TABLE_HEAD = ["#", "کاربر", "پروفایل", "نقش", "کدملی", "استان", "موجودی کیف‌پول", "وضعیت", "اولین ورود", "آخرین ورود"];

export function UserReportGrid({
                                 userReport,
                               }) {
  const avatar = '/assets/blank_profile.jpg';

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "کاربر": "name",
    "پروفایل": "photo",
    "نقش": "role",
    "کدملی": "national_code",
    "استان": "province_title",
    "موجودی کیف‌پول": "balance",
    "وضعیت": "status",
    "اولین ورود": "first_login",
    "آخرین ورود": "last_login",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "پروفایل": false,
    "نقش": true,
    "کدملی": true,
    "استان": true,
    "موجودی کیف‌پول": true,
    "وضعیت": true,
    "اولین ورود": true,
    "آخرین ورود": true,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {userReport.map(
          ({
             id,
             name,
             family,
             photo,
             role,
             phone,
             national_code,
             province_title,
             balance,
             status,
             first_login,
             last_login
           }, index) => {
            const isLast = index === userReport.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            const roleLabels = role.split(",").map(singleRole => Dict(singleRole)).join(", ");

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    {photo.length > 0 &&
                      <Avatar variant="circular" alt="tania andrew"
                              className="cursor-pointer border-white"
                              withBorder={true} size="sm"
                              src={getFileUrl(photo)}
                      />
                    }
                    {photo.length === 0 &&
                      <Avatar variant="circular" alt="tania andrew"
                              className="cursor-pointer border-white"
                              withBorder={true} size="sm"
                              src={avatar}
                      />
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {roleLabels}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(national_code)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {province_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(balance, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      status === 'enable' ? <BsCheckSquare color={"green"} size={30}/> :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <TableTdDateTime dateTime={first_login} />
                </td>


                <td className={classes}>
                  <TableTdDateTime dateTime={last_login} />
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}